export const tourSteps = [
  {
    target: '#main-content',
    content: 'Novo visual e experiência de bankline!'
  },
  {
    target: '#card-list',
    content: 'Principais valores e ações estão no topo'
  },
  {
    target: '#available-card',
    content: 'Só quer realizar a transferência? OK'
  },
  {
    target: '#anticipation-card',
    content: 'Quer só antecipar seus ganhos, OK, também!'
  },
  {
    target: '#financial-filter',
    content: 'Filtros que ajudam a encontrar o que deseja'
  },
  {
    target: '#main-results',
    content: 'Atualizações retroativas nunca mais e acompanhamento da evolução financeira da conta!!!'
  }
];
